const YOUTUBE_ID_PATTERN = /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/;

export function isYoutubeUrl(url: string | null | undefined) {
  return !!url && YOUTUBE_ID_PATTERN.test(url);
}

// Accepts watch, youtu.be, shorts, live, and embed links and returns the embeddable URL.
export function toYoutubeEmbedUrl(url: string) {
  const match = url.match(YOUTUBE_ID_PATTERN);
  return match ? `https://www.youtube.com/embed/${match[1]}?autoplay=1` : url;
}
